import { render, staticRenderFns } from "./contractInfo.vue?vue&type=template&id=6536af4c&"
import script from "./contractInfo.vue?vue&type=script&lang=js&"
export * from "./contractInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports